import {connect} from 'react-redux';
import TrialModal, {TrialModalProps} from './TrialModal';
import Action from '../../redux/Actions';
import {ModalStates} from '../../globals/Constants';
import ReduxState from '../../types/ReduxState';
import {Dispatch} from 'redux';
import UserModel from '../../types/UserModel';

const mapStateToProps = (state: ReduxState, ownProps: TrialModalContainerProps): Partial<TrialModalProps> => {
   return {
      themeName: state.themeName,
      currentUser: state.currentUser || {} as UserModel,
      onClose: ownProps.onClose,
      startNewReview: ownProps.startNewReview
   };
};

const mapDispatchToProps = (dispatch: Dispatch<ReduxState>): Partial<TrialModalProps> => {
   return {
      setModalState: (modalState: ModalStates) => {
         dispatch(Action.setModalState({modalState}));
      }
   };
};

export default connect(mapStateToProps, mapDispatchToProps)(TrialModal);

interface TrialModalContainerProps {
   startNewReview: boolean;
   onClose(): void;
}
